import axios from "axios";
import {getToken} from "../utils/cookies";

// create an axios instance
const service = axios.create({
    baseURL: "https://dotzerotech-filestore.dotzero.app",// url = base url + request ur
    timeout: 10000, // request timeout
});
service.interceptors.request.use(
    (config) => {
        // do something before request is sent

        if (getToken()) {
            config.headers["Authorization"] = "Bearer " + getToken();
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    },
    (error) => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

interface FilePreviewLink {
    url: string,
    expiry: number,
}

export async function getFilePreviewLink(fileName: string): Promise<FilePreviewLink> {
    const response = await service.post<FilePreviewLink>(`/general/tempLinks`, {
        "expiry": 60,
        "path": "/km/odoobook-readthedocs-io-sv-latest.pdf"
    })

    return response.data
}
